/**
 * @file 配置参数请求接口
 * @author xinqiang.wei 2022/7/18
 */
import { AgrasLang, AgrasRegion } from 'agras-i18n-utils'
import restRequest from '../restRequest'
import { getInitialData } from 'ice'

const BASE_URL = '/api'

interface IResult {
  data: ConfigInfo;
}

export interface ConfigInfo {
  background: string;
  favicon: string;
  logo: string;
  menu: string;
  meta_info?: IMetaInfo;
  name: string;
  region: RegionType; // 当前ip映射的地区
}

export interface IMetaInfo {
  // 问卷地址
  questionnaire_url: boolean;
  // 是否使用合并图层
  use_layer_group: boolean;
  // 是否为政府版，为了规避安全的审计，特意取了一个不相关的名字
  is_h: boolean;
  // 服务端各区域全量接口host
  base_paths_map?: BeBaseConfig[];
}

// 接口返回的三个区域
export enum RegionType {
  CN = 'CN',
  JP = 'JP',
  DEFAULT = 'default'
}
export interface BeBaseConfig {
  base_path: BeBaseHost;
  region: RegionType;
}

export interface BeBaseHost {
  ag_duplex_ws: string;
  ag_plot: string; // 地块服务
  ag_realtime_ws: string;
  ag_rtc_service: string;
  agro_cloud_be: string;
  ag: string; // 农服
  dtcp: string;
  dtcp_no_ssl_url: string;
  terra_cloud_be: string;
  ag_auth: string; // 登录认证
}

/**
 * 获取配置信息接口
 */
export const getConfigRequest = (): any => {
  return restRequest.get<IResult>(`${BASE_URL}/config`)
}


export interface Location {
  data: {
    country_code: AgrasRegion;
    language_code: AgrasLang;
  };
}

export const getLocationByIp = () => {
  return restRequest.get<Location>(`${BASE_URL}/ip_to_location`)
}

export const getServiceHost = (beType: keyof BeBaseHost = 'ag'): string | undefined => {
  const state = getInitialData()
  return state.initialStates.config?.baseBeHost?.[beType]
}

export function mixApi(url: string, server?: keyof BeBaseHost) {
  const ApiPrefix = getServiceHost(server || 'ag')
  return ApiPrefix + url
}
// 农服接口的返回体
export interface AgResponse<T> {
  data: T;
  status: number;
  code?: number|string;
  message?: string;
}